/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Avatar, Box, Drawer, Fab, makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';

const useStylesDrawer = makeStyles(theme => ({
  paper: {
    width: '100%',
    padding: 0,
    backgroundColor: theme.palette.contrastBackground,
    color: theme.palette.contrastText,
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% / 2)',
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(100% / 3)',
    },
    [theme.breakpoints.up('xl2')]: {
      width: 'calc(100% / 4)',
    },
    [theme.breakpoints.up('xl3')]: {
      width: 'calc(100% / 5)',
    },
  },
}));

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: '10rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  large: {
    width: '15rem',
    height: '15rem',
    marginBottom: '1.5rem',
    color: theme.palette.avatar.primary.text,
    backgroundColor: theme.palette.avatar.primary.background,
  },
  userInitialsText: {
    fontSize: '8rem',
    fontWeight: '400',
    marginTop: theme.spacing(0.25),
  },
  userName: {
    marginBottom: '1.5rem',
    color: theme.palette.profileSectionUsername,
  },
  button: {
    margin: theme.spacing(1),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1.5rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: '2rem',
    },
  },
  fabContainer: {
    padding: '1.25rem',
  },
  fab: {
    backgroundColor: theme.palette[theme.fabColor].main,
    color: theme.palette[theme.fabColor].contrastText,
    '&[data-focustype="key"]': {
      outline: 'none',
      boxShadow: `0 0 0 2px #fff, 0 0 0 4px ${theme.palette.focus}`,
    },
    '&:focus, &:active': {
      backgroundColor: theme.palette[theme.fabColor].active,
      outline: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette[theme.fabColor].hover,
    },
  },
}));

function UserInfoDrawer({ initials, fullName, isDrawerOpen, toggleDrawer }) {
  const classes = useStyles();
  const classesDrawer = useStylesDrawer();
  const isLargeOrBigger = useMediaQuery(theme => theme.breakpoints.up('lg'));

  return (
    <>
      <Drawer
        classes={classesDrawer}
        variant={isLargeOrBigger ? 'permanent' : 'temporary'}
        open={isDrawerOpen}
        onClose={toggleDrawer}
        anchor="right"
      >
        {!isLargeOrBigger && (
          <div className={classes.fabContainer}>
            <Fab size="medium" className={classes.fab} onClick={toggleDrawer} data-testid="user-profile-drawer-fab">
              <MenuOpenIcon />
            </Fab>
          </div>
        )}
        <Box className={classes.container}>
          <Avatar className={classes.large}>
            <Typography className={classes.userInitialsText}>{initials}</Typography>
          </Avatar>
          <Typography variant="h6" component="h6" className={classes.userName}>
            {fullName}
          </Typography>
          {/* <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            startIcon={<AddCircleOutlineIcon />}
            data-testid="user-management-add-logo"
          >
            {t('user-management.add-logo')}
          </Button> */}
        </Box>
      </Drawer>
    </>
  );
}

export default UserInfoDrawer;
